export default "__VITE_ASSET__8cd6cc62__"